export const EmptyCartImg = (): JSX.Element => {
  const className = 'icon icon--empty-cart';

  return (
    <svg
      width="216"
      height="216"
      viewBox="0 0 216 216"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <circle cx="108" cy="108" r="108" fill="#F9FAFB" />
      <g filter="url(#filter0_d_4379_54276)">
        <path
          d="M71.469 106.777L153.205 133.912L125.96 159.488L52.3659 120.501L71.469 106.777Z"
          fill="#02508D"
        />
        <path
          d="M128.246 145.146L174.978 109.642C174.978 109.642 175.452 110.636 175.571 111.322C175.801 112.645 175.038 114.718 175.038 114.718C175.038 114.718 172.686 149.175 168.694 152.808C166 155.261 133.725 181.26 133.725 181.26L128.246 145.146Z"
          fill="#0076CC"
        />
        <path
          d="M115.963 141.727C115.963 141.727 119.898 143.684 122.605 144.359C124.763 144.898 128.246 145.145 128.246 145.145L133.725 181.26C133.725 181.26 127.963 183.703 124.233 183.544C120.444 183.383 114.998 180.541 114.998 180.541L115.963 141.727Z"
          fill="#0076CC"
        />
        <path
          d="M37.6381 108.515L115.963 141.727L115.081 180.597L41.9046 149.973L37.6381 108.515Z"
          fill="#0076CC"
        />
        <path
          d="M32.3614 103.434C32.3614 103.434 33.5971 105.751 34.8315 106.831C35.8049 107.682 37.6665 108.543 37.6665 108.543L41.9611 150.029L40.5015 148.43L39.0419 146.072L32.3614 108.122V103.434Z"
          fill="#0076CC"
        />
        <path
          d="M35.3805 100.467L72.9922 70.6809L81.0135 112.506L69.5365 122.819L62.7396 120.667L53.8293 113.953L37.5635 108.7L35.0686 107.131L32.8856 104.621L35.3805 100.467Z"
          fill="#005FAA"
        />
        <path
          d="M72.9922 70.6584C72.9922 70.6584 74.8683 69.7959 76.1406 69.4627C77.9241 68.9955 78.9962 68.8284 80.835 68.9621C82.6423 69.0935 85.3327 70.1023 85.3327 70.1023L93.4286 73.1056L103.932 76.9835L125.704 86.1507L168.793 104.474C168.793 104.474 172.053 105.373 173.403 106.893C174.251 107.847 174.977 109.757 174.977 109.757L141.132 135.424L81.0135 112.506L72.9922 70.6584Z"
          fill="#056CBE"
        />
        <ellipse
          cx="62.868"
          cy="126.012"
          rx="3.44949"
          ry="4.99386"
          transform="rotate(-31.7153 62.868 126.012)"
          fill="#999797"
        />
        <ellipse
          cx="79.1847"
          cy="132.826"
          rx="3.44949"
          ry="4.99386"
          transform="rotate(-31.7153 79.1847 132.826)"
          fill="#999797"
        />
        <ellipse
          cx="62.53"
          cy="126.4"
          rx="2.95831"
          ry="4.31715"
          transform="rotate(-31.7153 62.53 126.4)"
          fill="#BAB9B9"
        />
        <ellipse
          cx="78.8467"
          cy="133.213"
          rx="2.95831"
          ry="4.31715"
          transform="rotate(-31.7153 78.8467 133.213)"
          fill="#BAB9B9"
        />
        <ellipse
          cx="62.2519"
          cy="126.597"
          rx="2.44409"
          ry="3.71651"
          transform="rotate(-31.7153 62.2519 126.597)"
          fill="#D9D9D9"
        />
        <ellipse
          cx="78.5686"
          cy="133.411"
          rx="2.44409"
          ry="3.71651"
          transform="rotate(-31.7153 78.5686 133.411)"
          fill="#D9D9D9"
        />
        <path
          d="M63.3021 119.416C63.3021 119.416 64.9324 119.149 66.0793 119.635C67.3778 120.186 68.0605 120.775 68.8673 121.932C69.5879 122.966 69.9853 123.686 70.0212 124.945C70.0451 125.781 69.6108 127.047 69.6108 127.047L65.9097 129.936C65.9097 129.936 66.8728 128.877 66.8014 127.333C66.735 125.896 66.3986 125.14 65.6226 123.926C65.0032 122.958 64.3719 122.428 63.4501 121.887C62.4686 121.311 60.4486 121.638 60.4486 121.638L63.3021 119.416Z"
          fill="#8E8D8D"
        />
        <path
          d="M79.6188 126.23C79.6188 126.23 81.2491 125.962 82.396 126.449C83.6945 127 84.3772 127.589 85.184 128.746C85.9046 129.78 86.302 130.5 86.3379 131.759C86.3618 132.595 85.9275 133.861 85.9275 133.861L82.2264 136.75C82.2264 136.75 83.1895 135.691 83.1181 134.146C83.0517 132.71 82.7153 131.954 81.9393 130.74C81.3199 129.771 80.6886 129.242 79.7668 128.701C78.7853 128.125 76.7653 128.452 76.7653 128.452L79.6188 126.23Z"
          fill="#8E8D8D"
        />
        <path
          d="M31.3196 96.9752L62.5118 119.943L60.3078 121.693L59.6866 122.137L59.2038 122.806L58.941 124.039L28.7574 101.303L31.3196 96.9752Z"
          fill="#5496F1"
        />
        <path
          d="M25.6106 91.4541C25.9244 90.0774 27.2094 88.2112 27.2094 88.2112L68.3455 56.1591L64.6226 65.0546L32.3278 90.4431C32.3278 90.4431 30.9437 91.2682 30.4332 92.1116C30.119 92.6308 29.9603 92.9642 29.8878 93.5668C29.7828 94.4405 29.9968 94.9799 30.403 95.7605C30.677 96.2871 31.3193 96.9735 31.3193 96.9735L28.757 101.303C28.757 101.303 27.1655 99.7146 26.535 98.4513C25.8761 97.1308 25.7523 96.2603 25.5829 94.7942C25.4331 93.4984 25.3207 92.7259 25.6106 91.4541Z"
          fill="#5496F1"
        />
        <path
          d="M83.3054 56.3952L87.1598 58.729L91.1231 61.4566L99.7753 67.4511L115.373 78.7244L103.962 77.114L92.5208 68.9349L85.125 63.7648L83.2533 62.6826L80.4029 61.1431C80.4029 61.1431 77.0887 60.0679 74.9094 60.1432C73.1603 60.2037 72.0907 60.2836 70.5228 61.0612C68.2961 62.1656 64.5662 65.1382 64.5662 65.1382L68.2046 56.2701C68.2046 56.2701 70.1945 55.304 71.5559 54.9505C73.1799 54.5287 74.1489 54.4514 75.8265 54.4806C77.3844 54.5077 78.273 54.6227 79.78 55.0186C81.2095 55.3942 83.3054 56.3952 83.3054 56.3952Z"
          fill="#5496F1"
        />
        <path
          d="M109.402 77.747L115.345 78.7226L115.485 78.7518L114.242 79.6959L113.309 80.5022L113.053 80.893L104.298 77.1713L109.402 77.747Z"
          fill="#5496F1"
        />
        <path
          d="M85.9253 129.735C85.9253 129.735 104.205 134.346 116.094 133.943C117.752 133.887 118.689 133.908 120.335 133.698C122.545 133.415 123.837 133.286 125.903 132.453C127.621 131.76 130.021 130.101 130.021 130.101L135.925 125.546L144.824 118.771L151.887 113.271L162.877 104.689L169.266 99.2679C169.266 99.2679 168.506 98.9202 168.007 98.7242C165.318 97.6666 160.749 97.2886 160.749 97.2886L153.067 96.2143L147.32 95.2404L146.003 95.033L141.891 93.2585L138.591 91.8557L136.8 91.083L136.532 89.6211L136.819 88.8656L137.159 88.4193L137.693 88.3676L138.619 88.4314L143.806 89.2042L152.553 90.5118L161.383 91.8762L168.587 93.1711C168.587 93.1711 169.942 93.3183 170.688 93.7218C171.21 94.0045 171.448 94.2578 171.887 94.6581C172.345 95.0759 172.627 95.3026 172.972 95.8179C173.396 96.4506 173.715 97.6206 173.715 97.6206C173.715 97.6206 173.849 99.2404 173.693 100.259C173.579 101.008 173.485 101.434 173.2 102.136C172.447 103.992 169.772 105.953 169.772 105.953L160.872 112.953L149.234 121.783L137.509 130.921L132.791 134.587C132.791 134.587 128.957 137.147 126.193 138.069C123.852 138.85 122.44 139.023 119.98 139.225C117.817 139.401 116.592 139.241 114.423 139.178C103.176 138.853 85.8795 135.265 85.8795 135.265L84.5345 134.973L85.8925 133.693L86.3574 131.788L85.9253 129.735Z"
          fill="#5496F1"
        />
        <path
          d="M116.531 77.8342C116.868 77.6406 117.081 77.5603 117.46 77.477C118.168 77.3218 118.616 77.4027 119.312 77.6047C120.071 77.8248 120.456 78.0335 121.101 78.4897C121.723 78.9297 122.089 79.2694 122.549 79.8771C122.984 80.4518 123.35 81.5399 123.35 81.5399C123.35 81.5399 123.573 82.4059 123.618 82.9737C123.657 83.4545 123.707 83.7366 123.608 84.2087C123.522 84.6232 123.207 85.2159 123.207 85.2159L119.974 83.8589C119.974 83.8589 119.618 83.0974 119.401 82.713C119.176 82.313 119.123 82.4922 118.828 82.1401C118.449 81.6868 118.165 81.3352 117.682 80.9942C117.182 80.6402 117.041 80.4635 116.465 80.2515C115.961 80.0658 115.42 80.2362 114.883 80.2515C113.967 80.2777 113.054 80.837 113.054 80.837C113.054 80.837 113.339 80.4733 113.536 80.2515C113.916 79.822 114.134 79.5788 114.583 79.2216C115.166 78.7574 115.886 78.2049 116.531 77.8342Z"
          fill="#8E8D8D"
        />
        <path
          d="M133.091 84.8795C133.428 84.6858 133.64 84.6055 134.02 84.5223C134.728 84.3671 135.175 84.448 135.872 84.6499C136.63 84.87 137.016 85.0787 137.661 85.5349C138.283 85.975 138.649 86.3146 139.109 86.9224C139.544 87.497 139.909 88.6385 139.909 88.6385C139.909 88.6385 137.795 88.1744 137.522 88.6749C137.294 89.094 136.87 89.5396 136.867 89.9073C136.863 90.3307 136.773 90.9985 136.773 90.9985L136.59 90.7342C136.59 90.7342 136.438 90.2864 136.221 89.902C135.996 89.502 135.738 89.3675 135.444 89.0153C135.065 88.5621 134.78 88.2105 134.298 87.8694C133.797 87.5155 133.727 87.5085 133.152 87.2965C132.648 87.1107 131.97 87.2812 131.433 87.2965C130.517 87.3226 129.714 87.8694 129.714 87.8694C129.714 87.8694 129.899 87.5186 130.095 87.2968C130.475 86.8673 130.694 86.6241 131.142 86.2668C131.725 85.8026 132.445 85.2502 133.091 84.8795Z"
          fill="#8E8D8D"
        />
        <path
          d="M113.053 80.9204C113.053 80.9204 113.676 80.229 114.21 80.0335C114.687 79.859 114.885 79.8092 115.391 79.8481C116.029 79.8971 116.504 80.1018 117.083 80.3754C117.619 80.6284 117.889 80.8404 118.341 81.2245C118.717 81.5441 118.923 81.7377 119.225 82.1283C119.48 82.457 119.612 82.6545 119.793 83.0295C119.944 83.3449 120.102 83.8708 120.102 83.8708L116.005 82.1016L113.053 80.9204Z"
          fill="#999797"
        />
        <path
          d="M129.612 88.0192C129.612 88.0192 130.235 87.3277 130.769 87.1323C131.246 86.9577 131.558 86.9884 132.064 87.0273C132.703 87.0764 133.063 87.2005 133.642 87.4742C134.178 87.7271 134.448 87.9391 134.9 88.3233C135.276 88.6428 135.482 88.8365 135.784 89.2271C136.039 89.5558 136.172 89.7532 136.352 90.1283C136.503 90.4437 136.661 90.9695 136.661 90.9695L132.564 89.2004L129.612 88.0192Z"
          fill="#999797"
        />
        <g filter="url(#filter1_dd_4379_54276)">
          <circle cx="137.213" cy="77.0164" r="23.0164" fill="#E66C37" />
        </g>
        <g filter="url(#filter2_d_4379_54276)">
          <path
            d="M143.939 75.1421V78.5136C143.939 80.0549 143.783 81.3714 143.471 82.4631C143.159 83.5549 142.709 84.4494 142.122 85.1466C141.535 85.8347 140.833 86.3439 140.017 86.6741C139.2 86.9952 138.292 87.1558 137.292 87.1558C136.494 87.1558 135.751 87.0549 135.063 86.853C134.375 86.642 133.755 86.3209 133.205 85.8897C132.664 85.4494 132.196 84.8897 131.801 84.2108C131.416 83.5319 131.118 82.72 130.907 81.7751C130.705 80.8301 130.604 79.743 130.604 78.5136V75.1421C130.604 73.6008 130.76 72.2889 131.072 71.2063C131.393 70.1238 131.847 69.2384 132.434 68.5504C133.021 67.8623 133.723 67.3623 134.54 67.0504C135.356 66.7293 136.264 66.5687 137.264 66.5687C138.072 66.5687 138.815 66.6696 139.494 66.8715C140.182 67.0733 140.797 67.3898 141.338 67.821C141.888 68.243 142.356 68.7935 142.742 69.4724C143.127 70.1421 143.42 70.9494 143.622 71.8944C143.833 72.8302 143.939 73.9127 143.939 75.1421ZM140.306 79.009V74.6329C140.306 73.8623 140.26 73.1925 140.168 72.6237C140.086 72.0458 139.962 71.5549 139.797 71.1513C139.631 70.7476 139.425 70.4219 139.177 70.1742C138.93 69.9173 138.645 69.7293 138.324 69.61C138.003 69.4907 137.65 69.4311 137.264 69.4311C136.787 69.4311 136.361 69.5274 135.985 69.7201C135.609 69.9036 135.292 70.1971 135.035 70.6008C134.778 71.0045 134.581 71.5412 134.443 72.2109C134.315 72.8714 134.251 73.6788 134.251 74.6329V79.009C134.251 79.7797 134.292 80.454 134.375 81.032C134.466 81.6099 134.595 82.1053 134.76 82.5182C134.934 82.931 135.141 83.2705 135.379 83.5365C135.627 83.7934 135.911 83.9861 136.232 84.1145C136.553 84.2338 136.907 84.2934 137.292 84.2934C137.778 84.2934 138.205 84.1971 138.572 84.0044C138.948 83.8118 139.264 83.509 139.521 83.0962C139.778 82.6741 139.971 82.1283 140.099 81.4586C140.237 80.7797 140.306 79.9632 140.306 79.009Z"
            fill="white"
          />
        </g>
        <g clipPath="url(#clip0_4379_54276)">
          <g filter="url(#filter3_d_4379_54276)">
            <path
              d="M163.579 60.7836L170.788 59.53"
              stroke="#E66C37"
              strokeWidth="3.65876"
              strokeLinecap="round"
              strokeLinejoin="round"
              shapeRendering="crispEdges"
            />
          </g>
          <g filter="url(#filter4_d_4379_54276)">
            <path
              d="M146.653 48.8723L145.399 41.663"
              stroke="#E66C37"
              strokeWidth="3.65876"
              strokeLinecap="round"
              strokeLinejoin="round"
              shapeRendering="crispEdges"
            />
          </g>
          <g filter="url(#filter5_d_4379_54276)">
            <path
              d="M157.597 51.3018L165.45 40.3166"
              stroke="#E66C37"
              strokeWidth="3.65876"
              strokeLinecap="round"
              strokeLinejoin="round"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_4379_54276"
          x="19.741"
          y="26.7833"
          width="168.582"
          height="164.736"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.65574" />
          <feGaussianBlur stdDeviation="2.65574" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4379_54276" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4379_54276"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_dd_4379_54276"
          x="110.439"
          y="54"
          width="53.5483"
          height="53.5483"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.75778" />
          <feGaussianBlur stdDeviation="1.87889" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4379_54276" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.939445" dy="0.939445" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_4379_54276"
            result="effect2_dropShadow_4379_54276"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_4379_54276"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_4379_54276"
          x="130.604"
          y="66.5687"
          width="15.2137"
          height="22.4659"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.87889" dy="1.87889" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4379_54276" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4379_54276"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_4379_54276"
          x="159.656"
          y="56.654"
          width="17.1461"
          height="11.1904"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.04623" dy="2.09247" />
          <feGaussianBlur stdDeviation="1.56935" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4379_54276" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4379_54276"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_4379_54276"
          x="141.477"
          y="38.787"
          width="11.1904"
          height="17.1461"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.04623" dy="2.09247" />
          <feGaussianBlur stdDeviation="1.56935" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4379_54276" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4379_54276"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_4379_54276"
          x="153.675"
          y="37.4408"
          width="17.789"
          height="20.9216"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.04623" dy="2.09247" />
          <feGaussianBlur stdDeviation="1.56935" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4379_54276" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4379_54276"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_4379_54276">
          <rect
            width="58.5402"
            height="58.5402"
            fill="white"
            transform="translate(172.983 29.4391) rotate(80.1353)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
